// PopupContext.js
import React, { createContext, useState, useContext } from "react";
import { Popup } from "../components";

const PopupContext = createContext();
export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({ children }) => {
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const [onConfirm, setOnConfirm] = useState(null);

    const showPopup = (title, subtitle, callback) => {
        setTitle(title);
        setSubtitle(subtitle);
        setOnConfirm(() => callback);
        setIsVisible(true);
    };

    const handleClose = () => {
        setIsVisible(false);
        setTitle("");
        setSubtitle("");
        setOnConfirm(null);
    };

    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        handleClose();
    };

    return (
        <PopupContext.Provider value={{ showPopup }}>
            {children}
            {isVisible && (
                <Popup title={title} subtitle={subtitle} handleClose={handleClose} handleConfirm={handleConfirm} />
            )}
        </PopupContext.Provider>
    );
};